import { defineMessage, t } from '@lingui/macro';

import { FIRST_NAME_FIELDNAME, LANGUAGE_FIELDNAME, LAST_NAME_FIELDNAME, SEX_FIELDNAME } from '../../../../hooks/useReadAdditionalData';
import useReadLoggedUser from '../../../../hooks/useReadLoggedUser';
import useReadParticipantsLangChoices from '../../../../hooks/useReadParticipantsLangChoices';
import { getCorrectClientFieldName } from '../../../../utils/business/participants';
import InputAccessControlCode, { ACCESS_CONTROL_FIELDNAME } from '../../../generic/form/InputAccessControlCode';
import InputBirthDate, { BIRTHDATE_FIELDNAME } from '../../../generic/form/InputBirthDate';
import InputEmail, { EMAIL_FIELDNAME } from '../../../generic/form/InputEmail';
import InputPhone, { PHONE_FIELDNAME } from '../../../generic/form/InputPhone';
import InputText from '../../../generic/form/InputText';
import Select from '../../../generic/form/Select';

const SpecificDataStandard = ({ data, fieldValue, onParticipantDataUpdate }) => {
  const { label, required } = data;

  const langChoices = useReadParticipantsLangChoices();
  const sexChoices = [
    { label: '-', value: '' },
    { label: t`Male`, value: 'M' },
    { label: t`Female`, value: 'F' },
  ];
  const loggedUser = useReadLoggedUser();

  const fieldProps = {
    isRequired: loggedUser && [PHONE_FIELDNAME, ACCESS_CONTROL_FIELDNAME].includes(label) ? false : required === 1,
    maxWidth: { base: '', md: '200px' },
    fieldValue: fieldValue,
    onChange: (fName, fieldValue, additionalData) => onParticipantDataUpdate(null, label, fieldValue, additionalData),
    className: 'ParticipantData_' + label,
  };

  return (
    <>
      {label === ACCESS_CONTROL_FIELDNAME && <InputAccessControlCode accessControlPartner={data.accessControlPartner} {...fieldProps} />}
      {label === FIRST_NAME_FIELDNAME && <InputText fieldLabel={firstNameLabel} fieldPlaceholder={firstNameLabel} {...fieldProps} />}
      {label === LAST_NAME_FIELDNAME && <InputText fieldLabel={lastNameLabel} fieldPlaceholder={lastNameLabel} {...fieldProps} />}

      {(label === BIRTHDATE_FIELDNAME || label === getCorrectClientFieldName(BIRTHDATE_FIELDNAME)) && <InputBirthDate {...fieldProps} />}

      {label === EMAIL_FIELDNAME && <InputEmail {...fieldProps} />}

      {label === LANGUAGE_FIELDNAME && <Select fieldLabel={langLabel} fieldChoices={langChoices} triggerChangeOnUpdate {...fieldProps} />}

      {label === PHONE_FIELDNAME && <InputPhone {...fieldProps} />}

      {label === SEX_FIELDNAME && <Select fieldLabel={sexLabel} fieldChoices={sexChoices} triggerChangeOnUpdate {...fieldProps} />}
    </>
  );
};

export default SpecificDataStandard;

const firstNameLabel = defineMessage({ message: 'First name' });
const lastNameLabel = defineMessage({ message: 'Last name' });
const langLabel = defineMessage({ message: 'Language' });
const sexLabel = defineMessage({ message: 'Sex' });
